import * as SliderPrimitive from "@radix-ui/react-slider";
import { FC } from "react";

import styles from "./slider.module.scss";
import { SliderPrimitiveProps } from "./slider.types";

const Slider: FC<SliderPrimitiveProps> = ({ ...props }) => {
  return (
    <SliderPrimitive.Root className={styles.Root} {...props}>
      <SliderPrimitive.Track className={styles.Track}>
        <SliderPrimitive.Range className={styles.Range} />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className={styles.Thumb} aria-label="Volume" />
      <SliderPrimitive.Thumb className={styles.Thumb} aria-label="Volume" />
    </SliderPrimitive.Root>
  );
};

export { Slider };
